import store from '@/store'

export default {
  dealerGuard (to, from, next) {
    store.dispatch('users/query', { ...to.query, with: 'branch,dealer' })
      .then(response => {
        return store.dispatch('branches/query')
      })
      .then(response => {
        next()
      })
      .catch(e => {
        console.log(e)
        next(e)
      })
  }
}



// WEBPACK FOOTER //
// ./src/guards/dealer.guards.js